import { render, staticRenderFns } from "./NpsCustomersList.vue?vue&type=template&id=58a6a08b&scoped=true"
import script from "./NpsCustomersList.vue?vue&type=script&lang=js"
export * from "./NpsCustomersList.vue?vue&type=script&lang=js"
import style0 from "./NpsCustomersList.vue?vue&type=style&index=0&id=58a6a08b&prod&lang=scss&scoped=true"
import style1 from "./NpsCustomersList.vue?vue&type=style&index=1&id=58a6a08b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a6a08b",
  null
  
)

export default component.exports